import { Base_Url } from "../../Base Url/BaseUrl";
import { postApiWithAuthenticated, getListWithAuthenticated} from "../../Api Method/ApiMethod";


const GalleryBaseUrl = `${Base_Url}/gallaryCat`;


export const gallaryCatList = async (params) => {
  let url = `${GalleryBaseUrl}/gallaryCatList`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};

export const addUpdateGallaryCat = async (url = '', params) => {
    
  
    const res = await postApiWithAuthenticated(`${GalleryBaseUrl}${url}`, params);
    return res;
  };

//   const res = await postApiWithAuthenticated(`${GalleryBaseUrl}${url}`, params);
//   return res;
// };

export const ChangeGallaryCatrStatus = async (id) => {
  let url = `${GalleryBaseUrl}/ChangeGallaryCatrStatus?GallaryCatKeyID=${id}`;
  const res = await getListWithAuthenticated(url);
  return res;
};


export const GetGallaryCatData = async (id) => {
    let url = `${GalleryBaseUrl}/getGallaryCat?GallaryCatKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };


export const GetGalleryCatLookupList = async () => {
    const url = `${GalleryBaseUrl}/GallaryCatLookup`;
  
    const res = await getListWithAuthenticated(url );
    return res;
  };
export const GallaryCatLookupForWeb = async () => {
    const url = `${GalleryBaseUrl}/GallaryCatLookupForWeb`;
  
    const res = await getListWithAuthenticated(url );
    return res;
  };
  
//   export const ChangeStateStatus = async (id,UserKeyID) => {
//     let url = `${GalleryBaseUrl}/ChangeStateStatus?StateID=${id}&UserKeyID=${UserKeyID}`;
//     const res = await getListWithAuthenticated(url);
//     return res;
//   };